import { firebaseAuthService } from '@/core/services';
import type { AuthRepository } from '../repositories/auth-repository';

export class LogoutUseCase {
  constructor(private readonly authRepository: AuthRepository) {}

  async execute(): Promise<void> {
    await firebaseAuthService.signOutUser();
    await this.authRepository.clearCache();
  }
}
